module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"ok":"Ок","cancel":"Отмена"}}')
  delete Component.options._Ctor
}
